import { render, staticRenderFns } from "./SagePaySlipPage.vue?vue&type=template&id=43180534&"
import script from "./SagePaySlipPage.vue?vue&type=script&lang=js&"
export * from "./SagePaySlipPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports